var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLocationFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5C9.81279 1.50266 7.71591 2.37271 6.16932 3.91931C4.62272 5.46591 3.75267 7.56278 3.75001 9.75C3.74743 11.5374 4.33136 13.2764 5.41223 14.7C5.41223 14.7 5.63723 14.9959 5.67338 15.0388L12 22.5L18.3293 15.0355C18.3626 14.9956 18.5878 14.6997 18.5878 14.6997L18.5889 14.6979C19.6691 13.2748 20.2527 11.5366 20.25 9.75C20.2473 7.56278 19.3773 5.46591 17.8307 3.91931C16.2841 2.37271 14.1872 1.50266 12 1.5ZM12 12.75C11.4067 12.75 10.8266 12.5741 10.3333 12.2444C9.83995 11.9148 9.45543 11.4462 9.22837 10.8981C9.00131 10.3499 8.9419 9.74667 9.05765 9.16473C9.17341 8.58279 9.45913 8.04824 9.87869 7.62868C10.2982 7.20912 10.8328 6.9234 11.4147 6.80764C11.9967 6.69189 12.5999 6.7513 13.1481 6.97836C13.6962 7.20542 14.1648 7.58994 14.4944 8.08329C14.8241 8.57664 15 9.15666 15 9.75C14.9991 10.5454 14.6828 11.3079 14.1203 11.8703C13.5579 12.4327 12.7954 12.7491 12 12.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLocationFilled);
export default __webpack_public_path__ + "static/media/Ic_location--filled.ede4322b2c358839ff26e2a6fee40aee.svg";
export { ForwardRef as ReactComponent };